module.exports = __webpack_public_path__ + "static/media/alphacolor-66JMudIjDTw-unsplash.275997ae.jpg";